import * as ko from 'knockout'
import { MessageBoxViewModel } from './MessageBoxViewModel'
import template from './messagebox.tpl.html'

interface Params {
  iconClass: string
  title: string
  description: string
  link: {
    text: string
    url: string
  }
}

if (!ko.components.isRegistered('message-box')) {
  ko.components.register('message-box', {
    viewModel: {
      createViewModel: (params: Params) => {
        const viewModel = new MessageBoxViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
